import { render, staticRenderFns } from "./thesis.vue?vue&type=template&id=b82c9130&scoped=true"
import script from "./thesis.vue?vue&type=script&lang=js"
export * from "./thesis.vue?vue&type=script&lang=js"
import style0 from "./thesis.vue?vue&type=style&index=0&id=b82c9130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82c9130",
  null
  
)

export default component.exports